import { storeMixin, storeGenerator } from '@/storeMixin'
import { merge } from 'lodash'

const contactdpi = merge(storeMixin.getMixin(), {
  state: {
    apiUrl: '/api/v1/organization/{profile}/contact-dpi',
    app: 'organization'
  }
})

const TYPES = (() =>
  merge(
    storeGenerator(
      { profile: 'GENERIC', app: 'organization', model: 'contactdpi' }
    ),
    { }
  )
)()

export { contactdpi, TYPES }
